export default __webpack_public_path__ + "static/media/ic_wmatic_225 (4).b25281c6.svg";